import { publicLogoPath } from '@orientaction/utils';
import { FC } from 'react';
import RedesignImage from '../../shared/components/RedesignImage';
import { useAuthLogoStyles } from './AuthLogo.styles';

export const AuthLogo: FC = () => {
  const cls = useAuthLogoStyles();

  return (
    <a
      href="https://www.orientaction-groupe.com/"
      target="_blank"
      rel="noreferrer"
      className={cls.logoLink}
    >
      <RedesignImage
        priority={true}
        src={`${publicLogoPath}/e-orientaction-redesign.png`}
        alt="E-ORIENTACTION"
        className={cls.logo}
      />
    </a>
  );
};
